import app from './../index';

export default class ArtikelController {

  constructor($routeParams) {

    this.artikelKategorien = app.api.artikelKategorien.query();

    if ($routeParams.id === "new") {
      this.artikel = new app.api.artikel();
      this.artikel.$resolved = true;
      this.artikel.Bestand = 0;
    } else {
      this.artikel = app.api.artikel.get({
        id: $routeParams.id
      });
    }
  }

  getArtikel(name) {
    return app.api.artikel.query({
        bezeichnung: name
      })
      .$promise
      .then((response) => {
        return response.Entries;
      });
  }

  save() {
    this.artikel.$save(() => {
      app.$window.history.back();
    });
  }
}

ArtikelController.$inject = ['$routeParams'];



/** WEBPACK FOOTER **
 ** ./public/app/artikel/ArtikelController.js
 **/